// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"7fa2ffe56d4cc6ffe1ba","691":"c30a3204c58f8b4d1b1b"}[chunkId] + ".js";
};